import React, { useState } from 'react'
import { CardBody, Container, Card } from 'reactstrap';
import SearchUsers from './component/SearchUser';
import UsersTable from './component/UsersTable';

const data = [
  {
    id: 10,
    status: 'Active',
    userName: '99207085860',
    firstName: 'Alexander',
    lastName: 'Rozer',
    entityName: 'Costal Community Health Service',
    role: 'users',
    accessLevel: 'Organisation',
    emailID: 'r.alexander.009@mymail.com',
    lastLoginDate: new Date(),
  },
  {
    id: 9,
    status: 'Inactive',
    userName: '99207085860',
    firstName: 'Alexander',
    lastName: 'Rozer',
    entityName: 'Costal Community Health Service',
    role: 'Organisation Admin',
    accessLevel: 'Organisation',
    emailID: 'r.alexander.009@mymail.com',
    lastLoginDate: new Date(),
  },
  {
    id: 8,
    status: 'Active',
    userName: '99207085860',
    firstName: 'Alexander',
    lastName: 'Rozer',
    entityName: 'Costal Community Health Service',
    role: 'users',
    accessLevel: 'Organisation',
    emailID: 'r.alexander.009@mymail.com',
    lastLoginDate: new Date(),
  },
  {
    id: 7,
    status: 'Active',
    userName: '99207085860',
    firstName: 'Alexander',
    lastName: 'Rozer',
    entityName: 'Costal Community Health Service',
    role: 'Organisation Admin',
    accessLevel: 'Organisation',
    emailID: 'r.alexander.009@mymail.com',
    lastLoginDate: new Date(),
  },
  {
    id: 6,
    status: 'Locked',
    userName: '99207085860',
    firstName: 'Alexander',
    lastName: 'Rozer',
    entityName: 'Costal Community Health Service',
    role: 'Organisation Admin',
    accessLevel: 'Organisation',
    emailID: 'r.alexander.009@mymail.com',
    lastLoginDate: new Date(),
  },
  {
    id: 5,
    status: 'Active',
    userName: '99207085860',
    firstName: 'Alexander',
    lastName: 'Rozer',
    entityName: 'Costal Community Health Service',
    role: 'users',
    accessLevel: 'Organisation',
    emailID: 'r.alexander.009@mymail.com',
    lastLoginDate: new Date(),
  },
  {
    id: 4,
    status: 'Active',
    userName: '99207085860',
    firstName: 'Alexander',
    lastName: 'Rozer',
    entityName: 'Costal Community Health Service',
    role: 'Organisation Admin',
    accessLevel: 'Organisation',
    emailID: 'r.alexander.009@mymail.com',
    lastLoginDate: new Date(),
  },
  {
    id: 3,
    status: 'Active',
    userName: '99207085860',
    firstName: 'Alexander',
    lastName: 'Rozer',
    entityName: 'Costal Community Health Service',
    role: 'users',
    accessLevel: 'Organisation',
    emailID: 'r.alexander.009@mymail.com',
    lastLoginDate: new Date(),
  },
  {
    id: 2,
    status: 'Active',
    userName: '99207085860',
    firstName: 'Alexander',
    lastName: 'Rozer',
    entityName: 'Costal Community Health Service',
    role: 'Organisation Admin',
    accessLevel: 'Organisation',
    emailID: 'r.alexander.009@mymail.com',
    lastLoginDate: new Date(),
  },
  {
    id: 1,
    status: 'Active',
    userName: '99207085860',
    firstName: 'Alexander',
    lastName: 'Rozer',
    entityName: 'Costal Community Health Service',
    role: 'Organisation Admin',
    accessLevel: 'Organisation',
    emailID: 'r.alexander.009@mymail.com',
    lastLoginDate: new Date(),
  },
]

const UserManagement = () => {
    const [loading, setLoading] = useState(false);
    const [usersData, setUsersData] = useState([]);
  
    const onSearch = (val) => {
      console.log(val)
        setLoading(true)
        setTimeout(() => {
            setUsersData(data);
            setLoading(false);
        }, 1000);
    }
  return (
    <div>
      <Container fluid className="my-3">
        <Card className="border-0 shadow-top">
          <CardBody className="section-devider-border">
            <SearchUsers onSearch={onSearch} />
          </CardBody>
          <CardBody className="pt-0">
            <UsersTable loading={loading} data={usersData} />
          </CardBody>
        </Card>
      </Container>
    </div>
  )
}

export default UserManagement;